import React from 'react';
import { Container } from 'react-bootstrap';

export default function Unauthorized(props) {
    return (
        <Container>
            You are not authorized to access this resource.
        </Container>
    );
}